const DBPREFIX = 'today_app'
class Tool {
  constructor () {
    this.prefix = DBPREFIX
    this.store = window.localStorage
  }
  /***
   * 设置缓存到本地
   * @param key
   * @param val
   */
  setLocalStorage (key, val) {
    let value = null
    if (!val && val !== 0) {
      this.store.removeItem(this.prefix + key)
      return false
    }
    try {
      value = JSON.stringify(val)
    } catch (e) {

    }
    this.store.setItem(this.prefix + key, value)
  }

  /****
   * 获取本地缓存
   * @param key
   */
  getLocalStorage (key) {
    let value = this.store.getItem(this.prefix + key)
    if (value !== null) {
      try {
        value = JSON.parse(value)
      } catch (e) {

      }
    }
    if (value !== null) {
      try {
        value = JSON.parse(value)
      } catch (e) {

      }
    }
    return value
  }
  /***
   * 获取所有的参数
   * @returns {{}}
  */
  getAllQueryString () {
    let url = window.location.href // 获取url中"?"符后的字串
    let theRequest = {}
    try {
      if (url.indexOf('#') > 0) {
        url = url.substr(0, url.indexOf('#'))
      }
      if (url.indexOf('?') !== -1) {
        let str = url.substr(url.indexOf('?') + 1, url.length)
        let strArr = str.split('&')
        for (let i = 0; i < strArr.length; i++) {
          theRequest[strArr[i].split('=')[0]] = decodeURIComponent(strArr[i].split('=')[1])
        }
      }
    } catch (e) {
      console.log(e)
    }
    return theRequest
  }
  /***
   * 获取用户信息
   */
  getMemberInfo (that, obj) {
    console.log('--getMemberInfo-')
    return new Promise(function (resolve, reject) {
      let userInfo = global.myStore.get(global.myStore.staticName.USER_INFO)
      console.log('--getMemberInfo-', userInfo.member_no)
      if (!userInfo || !userInfo.member_no) {
        let error = {
          status: 864,
          msg: '未知用户'
        }
        try {
          reject(error)
        } catch (e) {
          console.log(e)
        }
        return false
      }
      global.app.api.getMemberInfoByNo({}).then((memberRes) => {
        let data = memberRes.data
        if (!data || !data.member_mobile || data.member_mobile === '----') {
          let error = {
            status: 864,
            msg: '未知用户'
          }
          try {
            reject(error)
          } catch (e) {
            console.log(e)
          }
          return false
        }
        global.myStore.set(global.myStore.staticName.USER_INFO, data)
        global.tools.setLocalStorage(global.myStore.staticName.USER_INFO, data)
        that.$store.dispatch('updateUserInfo', data)
        resolve(data)
      }, (error) => {
        try {
          reject(error)
        } catch (e) {

        }
      })
    })
  }
}
export let tools = new Tool()



// WEBPACK FOOTER //
// ./src/utils/tools/tools.js